// extracted by mini-css-extract-plugin
export var paginationContainer = "_75-0";